/* unplugin-vue-components disabled */import { render } from "./AppsContainer.vue?vue&type=template&id=59657a3c"
import script from "./AppsContainer.vue?vue&type=script&lang=js"
export * from "./AppsContainer.vue?vue&type=script&lang=js"

import "./AppsContainer.vue?vue&type=style&index=0&id=59657a3c&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__